import React, { Component } from "react";
import "./style.css";
class IntelligentHeader extends Component {
  render() {
    const { handleVisible, type } = this.props;
    return (
      <div
        onClick={() => handleVisible(-1)}
        style={
          type === "advance"
            ? {
                borderBottom: 0,
                position: "fixed",
                zIndex: 999,
                boxShadow: "0px 2px 2px -1px #4D4D4D",
                maxWidth:'750px',
                opacity:'90%',
                backgroundColor:"#ffffff"
              }
            : {}
        }
        className="intelligentHeader_box"
      >
        <img
          alt=""
          src={require("../../../../../../../images/intelligent/return.png")}
        ></img>
        <span>返回</span>
      </div>
    );
  }
}

export default IntelligentHeader;



// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataHome/components/IntelligentAllMajorModal/components/IntelligentHeader/index.js